export const socialsData = {
    github: 'https://github.com/PrinceKumawat1109',
    facebook: 'https://www.facebook.com/prince.kumawat.3517',
    linkedIn: 'https://www.linkedin.com/in/prince-kumawat/',
    instagram: 'https://www.instagram.com/theprincekumawat/',
    twitter: 'https://twitter.com/PrinceK1109',
    stopstalk: 'https://www.stopstalk.com/user/profile/theprincekumawat',
    youtube: 'https://www.youtube.com/channel/UCrxYk70ViTZXS8cMGs06OsA'
}